import type { IWorkflowCatalogEntry } from '@common/interfaces/atlasai'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../../helpers/redux'
import * as actions from './actions'

export interface IWorkflowsListData {
  data: IWorkflowCatalogEntry[]
  total: number
  /**
   * Full, unfiltered set of registered workflow names. Backs the
   * `workflowName` autocomplete in the filter menu so the dropdown stays
   * stable regardless of the current filter selection.
   */
  workflowNames: string[]
}

/**
 * Read-only redux slice for the registry catalog of workflows. Mirrors the
 * prompts slice shape so the Workflows page can reuse the same loading-state
 * hooks and `loadMore`-aware reducer. No CRUD actions — workflows are
 * registered in code, not editable at runtime.
 */
export default combineReducers({
  list: createLoadingDataReducer<IWorkflowsListData>(
    [actions.LIST_WORKFLOWS_REQUEST],
    [], // no save actions — read-only
  ),
})
